import React from 'react'
import {
  Col,
  Row,
  Typography,
  Space,
} from 'antd'
import settingsStyles from './styles'
import NotificationSettings from './notifications'

export default function Settings() {
  const styles = settingsStyles()

  return (
    <Row style={styles.root}>
      <Col xs={20} md={18} lg={18} xl={14}>
        <Typography.Title level={3}>
          Settings
        </Typography.Title>

        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <NotificationSettings />
        </Space>
      </Col>
    </Row>
  )
}
